import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import axios from 'axios';
import { useEffect, useState } from 'react';
import notify from '../../../services/toasterService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { fetchDepartmentListEndPoint } from '../utils';

type Item = {
    companyId: number;
    companyName: string;
    pallets: any[];
    departments?: any[];
    glAccounts?: any[];
    selectedDepartment?: number;
    selectedGlAccount?: number;
    [key: string]: any;
};

interface IManageDeportments {
    filteredCompanyDetails: Item[];
    handleCloseModal: () => void;
    setFilteredCompanyDetails?: React.Dispatch<React.SetStateAction<Item[]>>;
    selectedPalletsData: any[];
    setSlectedPalletsData: React.Dispatch<React.SetStateAction<any[]>>;
}

export default function ManageDepartments({
    filteredCompanyDetails,
    handleCloseModal,
    setFilteredCompanyDetails,
    selectedPalletsData,
    setSlectedPalletsData,
}: IManageDeportments) {
    const handleUpdateDepartment = (ele: any, company: Item) => {
        const selectedDepartmentId = ele.target.value;

        const updatedCompanies = filteredCompanyDetails.map((comp) => {
            const selectedDepartment = company.departments?.find(
                (dept: any) => dept.id === Number(selectedDepartmentId)
            );
            if (comp.companyId === company.companyId) {
                return {
                    ...comp,
                    selectedDepartment: Number(selectedDepartmentId),
                    selectedGlAccount:
                        selectedDepartment?.glAccounts?.[0]?.id || null,
                    glAccounts: selectedDepartment?.glAccounts || [],
                };
            }
            return comp;
        });

        setFilteredCompanyDetails?.(updatedCompanies);
    };

    const handleUpdateGlAccount = (ele: any, company: Item) => {
        const selectedGlAccountId = ele.target.value;

        const updatedCompanies = filteredCompanyDetails.map((comp) => {
            if (comp.companyId === company.companyId) {
                return {
                    ...comp,
                    selectedGlAccount: Number(selectedGlAccountId),
                };
            }
            return comp;
        });

        setFilteredCompanyDetails?.(updatedCompanies);
    };

    const updateCompanyDepartments = async () => {
        const updatePalletsData = selectedPalletsData.map((pallet) => {
            const company = filteredCompanyDetails.find(
                (comp) => comp.companyId === pallet.companyId
            );
            const selectedDepartment = company?.departments?.find(
                (dept: any) => dept.id === company.selectedDepartment
            );
            return {
                ...pallet,
                department: selectedDepartment?.departmentName || null,
            };
        });
        setSlectedPalletsData(updatePalletsData);
        handleCloseModal();
    };

    return (
        <>
            <h4>Choose Department & GL Account</h4>

            <table className="table table-bordered" style={{ marginTop: 20 }}>
                <thead>
                    <tr className="m-0">
                        <th style={{ width: 150 }}>Company Name</th>
                        <th style={{ width: 150 }}>Department</th>
                        <th style={{ width: 150 }}> GL Account</th>
                    </tr>
                </thead>

                <tbody>
                    {filteredCompanyDetails?.map(
                        (company: Item, index: number) => (
                            <tr key={index}>
                                <td>{company.companyName}</td>
                                <td>
                                    <select
                                        className="formcontrol"
                                        value={company.selectedDepartment ?? ''}
                                        onChange={(ele) =>
                                            handleUpdateDepartment(ele, company)
                                        }
                                    >
                                        {company.departments?.map(
                                            (dept: any) => (
                                                <option
                                                    key={dept.id}
                                                    value={dept.id}
                                                >
                                                    {dept.departmentName}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </td>
                                <td>
                                    <select
                                        className="formcontrol"
                                        value={company.selectedGlAccount ?? ''}
                                        onChange={(ele) =>
                                            handleUpdateGlAccount(ele, company)
                                        }
                                    >
                                        {company.glAccounts?.map((gl: any) => (
                                            <option key={gl.id} value={gl.id}>
                                                {gl.glAccountName}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                {/* <ButtonComponent
                  style={{
                    color: "black",
                    margin: "20px",
                    padding: "10px 30px",
                  }}
                  className="eg-btn-secondary"
                >
                  SCAN BIN/BOX
                </ButtonComponent> */}

                <ButtonComponent
                    style={{
                        color: 'white',
                        backgroundColor: '#636799',
                        margin: '20px',
                        padding: '10px 20px',
                    }}
                    className="eg-btn-primary"
                    // onClick={() => {
                    //   SetSlectedPalletsData([
                    //     ...selectedPalletsData,
                    //     ...selectingPalletsData,
                    //   ]);
                    //   setShowAttachmentModal(false);
                    // }}
                    onClick={(e: any) => updateCompanyDepartments()}
                >
                    Proceed
                </ButtonComponent>
            </div>
        </>
    );
}
